module.exports = __webpack_public_path__ + "img/be-the-first-one.c4d02d10.svg";